import type { RouteObject } from 'react-router-dom';
import { Navigate, Outlet } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Login from '@/pages/login/page';
import Dashboard from '@/pages/dashboard/page';
import AppLayout from '@/components/feature/AppLayout';
import BugununIsleri from '@/pages/todays-jobs/page';
import AktifIsler from '@/pages/active-jobs/page';
import TamamlananIsler from '@/pages/completed-jobs/page';
import Musteriler from '@/pages/customers/page';
import Takip from '@/pages/follow-up/page';
import Tahsilatlar from '@/pages/payments/page';
import Finans from '@/pages/finance/page';
import Ekipler from '@/pages/teams/page';
import Raporlar from '@/pages/reports/page';
import Ayarlar from '@/pages/settings/page';
import TeklifTalepleri from '@/pages/requests/page';
import Teklifler from '@/pages/quotes/page';
import Randevu from '@/pages/appointments/page';
import { useAuth } from '@/lib/auth';
import { useAppStore } from '@/store/AppStore';

function AuthGate() {
  const { authorized, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line animate-spin text-2xl text-foreground-400" />
          <span className="text-sm text-foreground-500">Yükleniyor...</span>
        </div>
      </div>
    );
  }
  if (!authorized) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

function DataGate() {
  const { loading, error, reload } = useAppStore();
  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background-50 px-6 text-center">
        <i className="ri-error-warning-line text-3xl text-foreground-400" />
        <div>
          <p className="text-base font-semibold text-foreground-900">Veriler yüklenemedi</p>
          <p className="mt-1 text-sm text-foreground-500">{error}</p>
        </div>
        <button
          type="button"
          onClick={reload}
          className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-semibold text-white hover:bg-primary-600"
        >
          <i className="ri-refresh-line" />
          Tekrar Dene
        </button>
      </div>
    );
  }
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line animate-spin text-2xl text-foreground-400" />
          <span className="text-sm text-foreground-500">Veriler yükleniyor...</span>
        </div>
      </div>
    );
  }
  return <Outlet />;
}

function DashboardLayout() {
  return (
    <AppLayout>
      <DataGate />
    </AppLayout>
  );
}

const routes: RouteObject[] = [
  { path: '/login', element: <Login /> },
  {
    element: <AuthGate />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          { path: '/', element: <Dashboard /> },
          { path: '/bugunun-isleri', element: <BugununIsleri /> },
          { path: '/teklif-talepleri', element: <TeklifTalepleri /> },
          { path: '/teklifler', element: <Teklifler /> },
          { path: '/randevu', element: <Randevu /> },
          { path: '/aktif-isler', element: <AktifIsler /> },
          { path: '/musteriler', element: <Musteriler /> },
          { path: '/takip', element: <Takip /> },
          { path: '/tamamlanan-isler', element: <TamamlananIsler /> },
          { path: '/tahsilatlar', element: <Tahsilatlar /> },
          { path: '/finans', element: <Finans /> },
          { path: '/ekipler', element: <Ekipler /> },
          { path: '/raporlar', element: <Raporlar /> },
          { path: '/ayarlar', element: <Ayarlar /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;